export const aboutContent = {
  brandName: '韩漫漫画网',
  slogan: '韩漫在线阅读的首选平台',
  introduction: '韩漫漫画网成立于2020年，是国内领先的韩国漫画在线免费阅读平台。我们致力于为华语读者提供最全面、最新、最优质的韩漫资源。平台收录了数千部韩国漫画，涵盖恋爱、动作、奇幻、悬疑、恐怖、喜剧等多种类型，所有内容均采用无删减下拉式阅读模式，确保读者能够获得原汁原味的阅读体验。',
  features: [
    {
      title: '海量韩漫资源',
      description: '收录数千部韩国漫画，涵盖各类热门题材，每日更新，确保读者能够第一时间阅读到最新内容。',
      icon: 'ri-stack-line',
    },
    {
      title: '无删减完整版',
      description: '所有漫画均以原版完整内容呈现，无任何删减或修改，保留最原汁原味的故事情节和画面。',
      icon: 'ri-file-copy-line',
    },
    {
      title: '下拉式阅读',
      description: '采用最便捷的下拉式阅读模式，流畅丝滑的阅读体验，让您沉浸在漫画的世界中。',
      icon: 'ri-scroll-to-bottom-line',
    },
    {
      title: '完全免费',
      description: '平台所有内容完全免费，无需付费订阅，无需会员，所有人都可以畅享韩漫阅读的乐趣。',
      icon: 'ri-money-cny-circle-line',
    },
    {
      title: '多端适配',
      description: '完美适配电脑、平板、手机等多种设备，随时随地享受韩漫在线阅读的便捷体验。',
      icon: 'ri-device-line',
    },
    {
      title: '分类齐全',
      description: '提供详细的分类系统，方便读者快速找到心仪的作品，支持按类型、热度、更新时间等多种方式筛选。',
      icon: 'ri-grid-line',
    },
  ],
  stats: [
    { label: '收录漫画', value: '3,000+' },
    { label: '每日更新', value: '50+' },
    { label: '累计读者', value: '500万+' },
    { label: '好评率', value: '99.2%' },
  ],
  testimonials: [
    {
      name: '漫画迷小王',
      avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%2C%20casual%20style%2C%20friendly%20smile%2C%20clean%20simple%20background%2C%20professional%20headshot%20style%2C%20warm%20lighting&width=200&height=200&seq=avatar-user-1&orientation=squarish',
      content: '韩漫漫画网真的太棒了！资源超全，更新速度也很快，而且完全免费。这里的下拉式阅读体验比很多付费平台还好，强烈推荐给所有韩漫爱好者。',
      rating: 5,
    },
    {
      name: '小琳爱看漫',
      avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%2C%20casual%20style%2C%20happy%20smile%2C%20clean%20simple%20background%2C%20professional%20headshot%20style%2C%20warm%20lighting&width=200&height=200&seq=avatar-user-2&orientation=squarish',
      content: '从朋友那里知道这个网站后就爱上了，每天都要来刷一下有没有更新。分类很齐全，找漫画特别方便，而且真的是无删减版本，剧情完整！',
      rating: 5,
    },
    {
      name: '深夜追漫人',
      avatar: 'https://readdy.ai/api/search-image?query=Korean%20man%20portrait%2C%20modern%20casual%20style%2C%20thoughtful%20expression%2C%20clean%20simple%20background%2C%20professional%20headshot%20style%2C%20soft%20lighting&width=200&height=200&seq=avatar-user-3&orientation=squarish',
      content: '作为资深韩漫迷，我用过很多平台，韩漫漫画网是我最满意的。更新及时，翻译质量高，而且下拉式阅读真的超级方便，一滑到底，爽！',
      rating: 5,
    },
    {
      name: '动漫达人阿杰',
      avatar: 'https://readdy.ai/api/search-image?query=Asian%20young%20man%20portrait%2C%20stylish%20casual%20look%2C%20confident%20smile%2C%20clean%20background%2C%20professional%20headshot%2C%20bright%20lighting&width=200&height=200&seq=avatar-user-4&orientation=squarish',
      content: '这个网站的韩漫资源真的无敌，很多冷门作品都能找到。而且最重要的是完全免费，没有任何套路，真的是为爱发电的好平台。',
      rating: 5,
    },
  ],
  contactInfo: {
    email: 'contact@hanmanmh.com',
    wechat: '韩漫漫画网',
    qq: '1234567890',
    address: '在线服务平台，服务全国韩漫爱好者',
  },
  faq: [
    {
      question: '韩漫漫画网是否真的完全免费？',
      answer: '是的，韩漫漫画网承诺所有漫画内容完全免费，无需支付任何费用，无需购买会员或订阅，您可以直接在网站上畅享所有韩漫资源。',
    },
    {
      question: '漫画内容是否有删减？',
      answer: '我们坚持提供无删减的完整版漫画内容，保留原作者的全部创作意图和故事情节。所有漫画均为原版内容，绝不进行任何删减或修改。',
    },
    {
      question: '更新频率如何？',
      answer: '韩漫漫画网每日都会更新，确保读者能够在第一时间阅读到最新的漫画章节。热门漫画通常会在韩文原版更新后24小时内提供中文版本。',
    },
    {
      question: '支持哪些设备阅读？',
      answer: '韩国漫画在线阅读平台完美适配电脑、平板和手机等多种设备。采用响应式设计，无论是大屏幕还是小屏幕，都能获得良好的阅读体验。',
    },
    {
      question: '如何找到想看的漫画？',
      answer: '您可以通过网站的搜索功能直接搜索漫画名称，也可以通过分类浏览功能按类型筛选漫画。我们还提供热门推荐和最新更新列表，帮助您发现更多精彩内容。',
    },
  ],
};